import React from "react";
import Sidebar from "../components/sidebar/Sidebar";
import Workflow from "../components/workflow/Workflow";
import { useLocation, useParams } from "react-router-dom";

// Workflowpage component renders the workflow interface with a sidebar and workflow content.
// It receives an openDrawer prop to control the sidebar drawer and extracts route parameters and user data.
const Workflowpage = ({ openDrawer }) => {
  // useParams hook provides access to route parameters such as processType and engagementId.
  const params = useParams();

  // useLocation hook provides access to the location object, which contains state data passed through navigation.
  const location = useLocation();

  // WorkflowData object is constructed using route parameters and other configurations.
  const WorkflowData = {
    processType: params.processType, // Type of process (e.g., data-all, data-ingestion)
    engagement_id: params.engagementId, // Engagement ID from route parameters
    isSearchFilterVisible: true, // Boolean flag to show or hide search filters
    dashboard: false, // Boolean flag indicating if the dashboard view is enabled
  };

  // UserData object extracts user-specific data from the location state for rendering and authentication purposes.
  const UserData = {
    roles: location.state?.roles, // User roles (e.g., admin, user)
    isAdmin: location.state?.isAdmin, // Boolean flag indicating if the user is an admin
    isAuthenticated: location.state?.isAuthenticated, // Boolean flag indicating if the user is authenticated
    refreshToken: location.state?.refreshToken, // Token used to refresh user session
    accessToken: location.state?.accessToken, // Token used for API requests
    userId: location.state?.userId, // Unique identifier for the user
    username: location.state?.username, // Username of the authenticated user
  };

  return (
    <>
      {/* Sidebar component with openDrawer and userData props. 
          The 'active' prop dynamically sets the active menu item based on the processType parameter. */}
      <Sidebar
        openDrawer={openDrawer}
        userData={UserData}
        active={
          params.processType === "data-all"
            ? 6.1
            : params.processType === "data-ingestion"
            ? 6.2
            : params.processType === "data-transformation"
            ? 6.3
            : 6
        }
      />

      {/* Workflow component that renders the main content for the workflow page. 
          It receives WorkflowData and userData props for functionality and customization. */}
      <Workflow
        openDrawer={openDrawer}
        WorkflowData={WorkflowData}
        userData={UserData}
      />
    </>
  );
};

export default Workflowpage;
